// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { GoArrowUpRight } from "react-icons/go";

// import SelectNetworkModal from "./SelectNetworkModal";
// import AddTokenModal from "./AddTokenModal";
// import SendModal from "./SentModal";
// import ReceiveModal from "./RecivedModal";
// import WalletTableSkeleton from "./WalletTableSkeleton";

// export default function WalletDetail() {
//   const [showMainnet, setShowMainnet] = useState(false);
//   const [showTestnet, setShowTestnet] = useState(true);
//   const [isSendModalOpen, setIsSendModalOpen] = useState(false);
//   const [isReceiveModalOpen, setIsReceiveModalOpen] = useState(false);
//   const [portfolioNetworth, setPortfolioNetworth] = useState(null);
//   const [allTokenBalances, setAllTokenBalances] = useState([]);
//   const [evmBalance, setEvmBalance] = useState(0);
//   const [isAPILoading, setIsAPILoading] = useState(true);

//   const { activeNetwork, token } = useSelector((state) => state.user);
//   const navigate = useNavigate();

//   const nativeToken = activeNetwork?.nativeCurrency?.symbol || "ETH";
//   const selectedToken = "USDT";

//   const MAINNET_CHAIN_IDS = [1, 101, 43114, 56, 137];
//   const TESTNET_CHAIN_IDS = [103, 43113, 97, 80002, 11155111];

//   const getNetworkName = (chainId) => {
//     switch (chainId) {
//       case 103: return "Solana DevNet";
//       case 101: return "Solana MainNet";
//       case 43113: return "Avalanche Fuji";
//       case 43114: return "Avalanche Mainnet";
//       case 97: return "BSC Testnet";
//       case 56: return "BSC Mainnet";
//       case 80002: return "Polygon Amoy";
//       case 137: return "Polygon";
//       case 11155111: return "Sepolia Testnet";
//       case 1: return "Ethereum Mainnet";
//       default: return "Unknown Network";
//     }
//   };

//   const groupBalancesByChain = (balances) => {
//     const grouped = {};
//     balances.forEach((token) => {
//       const chainId = token.chainId;
//       if (!grouped[chainId]) {
//         grouped[chainId] = { chainId, balances: [] };
//       }
//       grouped[chainId].balances.push(token);
//     });
//     return Object.values(grouped);
//   };

//   const fetchPortfolio = async () => {
//     const headers = { authorization: `Bearer ${token}` };
//     try {
//       const response = await axios.get("http://159.203.35.6:8080/wallet/getAllChainAssets", { headers });
//       if (response.status === 200) {
//         const data = response.data;
//         const groupedBalances = groupBalancesByChain(data?.balances || []);
//         setAllTokenBalances(groupedBalances);
//         setPortfolioNetworth(data?.totalUsdValue || 0);
//         setEvmBalance(data?.nativeEquivalent || 0);
//       }
//     } catch (error) {
//       console.error("Error fetching portfolio:", error);
//       toast.error(error?.response?.data?.error || "Failed to fetch portfolio");
//       if (error?.response?.status === 403) {
//         navigate("/connect-wal");
//       }
//     } finally {
//       setIsAPILoading(false);
//     }
//   };

//   const fetchNetworkMode = async () => {
//     try {
//       const response = await axios.get("http://159.203.35.6:8080/wallet/checkNetworkMode", {
//         headers: { authorization: `Bearer ${token}` },
//       });
//       if (response.status === 200) {
//         setShowMainnet(response.data?.showMainnet);
//         setShowTestnet(response.data?.showTestnet);
//       }
//     } catch (err) {
//       console.error("Failed to check network mode:", err);
//     }
//   };

//   const handleToggleNetworkSelection = async () => {
//     try {
//       const updatedShowTestnet = !showTestnet;
//       const updatedShowMainnet = !showMainnet;

//       const response = await axios.post(
//         "http://159.203.35.6:8080/wallet/switchNetworks",
//         { showTestnet: updatedShowTestnet, showMainnet: updatedShowMainnet },
//         { headers: { authorization: `Bearer ${token}` } }
//       );

//       if (response.status === 200) {
//         setShowMainnet(updatedShowMainnet);
//         setShowTestnet(updatedShowTestnet);
//         toast.success(`Switched to ${updatedShowTestnet ? "Testnet" : "Mainnet"} mode`);
//         fetchPortfolio();
//       }
//     } catch (error) {
//       console.error("Error switching network:", error);
//       toast.error("Failed to switch network mode");
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       setIsAPILoading(true);
//       fetchNetworkMode();
//       fetchPortfolio();
//     }
//   }, [activeNetwork, token]);

//   const handleToggleReceiveModal = () => setIsReceiveModalOpen(!isReceiveModalOpen);
//   const handleToggleSendModal = () => setIsSendModalOpen(!isSendModalOpen);

//   return (
//     <div className="wallett-container">
//       <div className="header-container">
//         <div className="header-content">
//           <h2 className="header-subtitle">
//             <span className="color-sp"> Lookna Wallet</span>
//           </h2>
//         </div>
//         <p className="header-description">
//           Send, receive, and manage your crypto seamlessly with a secure, smart, and easy-to-use digital wallet.
//         </p>
//         <div className="details-borders"></div>
//       </div>

//       <div className="wallett-actions">
//         <button className="wallett-button wallett-send" onClick={handleToggleSendModal}>
//           Send <GoArrowUpRight />
//         </button>
//         <button className="wallett-button wallett-receive" onClick={handleToggleReceiveModal}>
//           Receive
//         </button>
//         <button className="wallett-button wallett-receive" onClick={() => navigate("/history")}>
//           Transactions
//         </button>
//         <div className="network-selection-container">
//           <button className="wallett-button wallett-network-toggle" onClick={handleToggleNetworkSelection}>
//             Switch Network
//           </button>
//           <div className="network-status">
//             {showTestnet ? "Testnet Mode" : "Main-net Mode"}
//           </div>
//         </div>
//       </div>

//       {isAPILoading ? (
//         <WalletTableSkeleton />
//       ) : (
//         <>
//           <div className="wallett-balance">
//             <div className="wallett-balance-amount">
//               <span>
//                 {selectedToken === "USDT"
//                   ? portfolioNetworth
//                     ? `USD $ ${portfolioNetworth.toFixed(8)}`
//                     : "USD"
//                   : `${nativeToken} ${Number(evmBalance).toFixed(8)}`}
//               </span>
//             </div>
//           </div>

//           {allTokenBalances.some(chain => chain.balances?.length > 0) ? (
//             <div className="wallett-tokens">
//               <table className="wallett-table">
//                 <thead>
//                   <tr>
//                     <th className="wallett-table-header">Tokens</th>
//                     <th className="wallett-table-header">Balance</th>
//                     <th className="wallett-table-header">Change</th>
//                     <th className="wallett-table-header">Price</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {allTokenBalances.map((chainData, idx) =>
//                     chainData.balances.map((token, tokenIdx) => (
//                       <tr key={`${idx}-${token.tokenAddress || token.mint || tokenIdx}`}>
//                         <td>
//                           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                             {token?.logo ? (
//                               <img
//                                 src={token?.logo}
//                                 alt="Token Logo"
//                                 width={24}
//                                 height={24}
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.style.display = "none";
//                                 }}
//                                 style={{
//                                   width: 24,
//                                   height: 24,
//                                   objectFit: "contain",
//                                   borderRadius: "50%",
//                                 }}
//                               />
//                             ) : (
//                               <div
//                                 style={{
//                                   width: 24,
//                                   height: 24,
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                   borderRadius: "50%",
//                                   background: "#f0f0f0",
//                                   fontSize: 14,
//                                 }}
//                               >
//                                 🔠
//                               </div>
//                             )}
//                             <span style={{ color: "white" }}>
//                               {token?.symbol?.slice(0, 5) || "in progress"}
//                             </span>
//                           </div>
//                         </td>

//                         <td>
//                           {token?.balance || 0.0}
//                           <br />
//                           <span
//                             style={{
//                               fontSize: "12px",
//                               opacity: 0.8,
//                               color: "gold",
//                             }}
//                           >
//                             ($
//                             {Number(token?.usd_value || token?.tokenValueUsd || 0)})
//                           </span>
//                         </td>

//                         <td
//                           className="wallett-token-change"
//                           style={{
//                             color:
//                               parseFloat(token?.usdPrice24hrPercentChange) > 0
//                                 ? "green"
//                                 : parseFloat(token?.usdPrice24hrPercentChange) < 0
//                                 ? "red"
//                                 : "yellow",
//                           }}
//                         >
//                           {token?.usdPrice24hrPercentChange !== undefined
//                             ? `${token.usdPrice24hrPercentChange}%`
//                             : "N/A"}
//                         </td>

//                         <td className="wallett-token-price">
//                           {token?.usdPrice ? `$${token.usdPrice}` : "0.00"}
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           ) : (
//             <div style={{ color: "white", textAlign: "center", marginTop: "2rem" }}>
//               No token balances found.
//             </div>
//           )}
//         </>
//       )}

//       <ReceiveModal isOpen={isReceiveModalOpen} setIsOpen={setIsReceiveModalOpen} onClose={handleToggleReceiveModal} />
//       <SendModal isOpen={isSendModalOpen} onClose={handleToggleSendModal} />
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { GoArrowUpRight } from "react-icons/go";

import SendModal from "./SentModal";
import ReceiveModal from "./RecivedModal";
import WalletTableSkeleton from "./WalletTableSkeleton";

export default function WalletDetail() {
  const [showMainnet, setShowMainnet] = useState(false);
  const [showTestnet, setShowTestnet] = useState(true);
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const [isReceiveModalOpen, setIsReceiveModalOpen] = useState(false);
  const [portfolioNetworth, setPortfolioNetworth] = useState(null);
  const [allTokenBalances, setAllTokenBalances] = useState([]);
  const [evmBalance, setEvmBalance] = useState(0);
  const [isAPILoading, setIsAPILoading] = useState(true);

  const { activeNetwork, token } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const nativeToken = activeNetwork?.nativeCurrency?.symbol || "ETH";
  const selectedToken = "USDT";

  const getNetworkName = (chainId) => {
    switch (chainId) {
      case 103: return "Solana DevNet";
      case 101: return "Solana MainNet";
      case 43113: return "Avalanche Fuji";
      case 43114: return "Avalanche Mainnet";
      case 97: return "BSC Testnet";
      case 56: return "BSC Mainnet";
      case 80002: return "Polygon Amoy";
      case 137: return "Polygon";
      case 11155111: return "Sepolia Testnet";
      case 1: return "Ethereum Mainnet";
      default: return "Unknown Network";
    }
  };

  const groupBalancesByChain = (balances) => {
    const grouped = {};
    balances.forEach((token) => {
      const chainId = token.chainId;
      if (!grouped[chainId]) {
        grouped[chainId] = { chainId, balances: [] };
      }
      grouped[chainId].balances.push(token);
    });
    return Object.values(grouped);
  };

  const fetchPortfolio = async () => {
    const headers = { authorization: `Bearer ${token}` };
    try {
      setIsAPILoading(true); // Ensure loading starts
      const response = await axios.get("http://159.203.35.6:8080/wallet/getAllChainAssets", { headers });
      if (response.status === 200) {
        const data = response.data;
        const groupedBalances = groupBalancesByChain(data?.balances || []);
        setAllTokenBalances(groupedBalances);
        setPortfolioNetworth(data?.totalUsdValue || 0);
        setEvmBalance(data?.nativeEquivalent || 0);
      }
    } catch (error) {
      console.error("Error fetching portfolio:", error);
      toast.error(error?.response?.data?.error || "Failed to fetch portfolio");
      if (error?.response?.status === 403) {
        navigate("/connect-wal");
      }
    } finally {
      setIsAPILoading(false); // Always stop loading
    }
  };

  const fetchNetworkMode = async () => {
    try {
      const response = await axios.get("http://159.203.35.6:8080/wallet/checkNetworkMode", {
        headers: { authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        setShowMainnet(response.data?.showMainnet);
        setShowTestnet(response.data?.showTestnet);
      }
    } catch (err) {
      console.error("Failed to check network mode:", err);
    }
  };

  const handleToggleNetworkSelection = async () => {
    try {
      const updatedShowTestnet = !showTestnet;
      const updatedShowMainnet = !showMainnet;

      const response = await axios.post(
        "http://159.203.35.6:8080/wallet/switchNetworks",
        { showTestnet: updatedShowTestnet, showMainnet: updatedShowMainnet },
        { headers: { authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        setShowMainnet(updatedShowMainnet);
        setShowTestnet(updatedShowTestnet);
        toast.success(`Switched to ${updatedShowTestnet ? "Testnet" : "Mainnet"} mode`);
        fetchPortfolio();
      }
    } catch (error) {
      console.error("Error switching network:", error);
      toast.error("Failed to switch network mode");
    }
  };

  useEffect(() => {
    if (token) {
      fetchNetworkMode();
      fetchPortfolio();
    }
  }, [activeNetwork, token]);

  const handleToggleReceiveModal = () => setIsReceiveModalOpen(!isReceiveModalOpen);
  const handleToggleSendModal = () => setIsSendModalOpen(!isSendModalOpen);

  return (
    <div className="wallett-container">
      <div className="header-container">
        <div className="header-content">
          <h2 className="header-subtitle">
            <span className="color-sp">Lookna Wallet</span>
          </h2>
        </div>
        <p className="header-description">
          Send, receive, and manage your crypto seamlessly with a secure, smart, and easy-to-use digital wallet.
        </p>
        <div className="details-borders"></div>
      </div>

      <div className="wallett-actions">
        <button className="wallett-button wallett-send" onClick={handleToggleSendModal}>
          Send <GoArrowUpRight />
        </button>
        <button className="wallett-button wallett-receive" onClick={handleToggleReceiveModal}>
          Receive
        </button>
        <button className="wallett-button wallett-receive" onClick={() => navigate("/history")}>
          Transactions
        </button>
          <button className="wallett-button wallett-receive" onClick={fetchPortfolio}>
          Refresh
        </button>
        <div className="network-selection-container">
          <button className="wallett-button wallett-network-toggle" onClick={handleToggleNetworkSelection}>
            Switch Network
          </button>
          <div className="network-status">
            {showTestnet ? "Testnet Mode" : "Mainnet Mode"}
          </div>
        </div>
      
      </div>

      {isAPILoading ? (
        <WalletTableSkeleton />
      ) : (
        <>
          <div className="wallett-balance">
            <div className="wallett-balance-amount">
              <span>
                {selectedToken === "USDT"
                  ? portfolioNetworth
                    ? `USD $ ${portfolioNetworth.toFixed(8)}`
                    : "USD"
                  : `${nativeToken} ${Number(evmBalance).toFixed(8)}`}
              </span>
            </div>
          </div>

          {allTokenBalances.some(chain => chain.balances?.length > 0) ? (
            <div className="wallett-tokens">
              <table className="wallett-table">
                <thead>
                  <tr>
                    <th>Tokens</th>
                    <th>Balance</th>
                    <th>Change</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {allTokenBalances.map((chainData, idx) =>
                    chainData.balances.map((token, tokenIdx) => (
                      <tr key={`${idx}-${token.tokenAddress || token.mint || tokenIdx}`}>
                        <td>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            {token?.logo ? (
                              <img
                                src={token?.logo}
                                alt="Token Logo"
                                width={24}
                                height={24}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = "none";
                                }}
                                style={{
                                  width: 24,
                                  height: 24,
                                  objectFit: "contain",
                                  borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <div style={{
                                width: 24,
                                height: 24,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "50%",
                                background: "#f0f0f0",
                                fontSize: 14,
                              }}>🔠</div>
                            )}
                            <span style={{ color: "white" }}>
                              {token?.symbol?.slice(0, 5) || "N/A"}
                            </span>
                          </div>
                        </td>
                        <td>
                          {token?.balance || 0.0}
                          <br />
                          <span style={{ fontSize: "12px", opacity: 0.8, color: "gold" }}>
                            (${Number(token?.usd_value || token?.tokenValueUsd || 0).toFixed(5)})
                          </span>
                        </td>
                        <td style={{
                          color:
                            parseFloat(token?.usdPrice24hrPercentChange) > 0
                              ? "green"
                              : parseFloat(token?.usdPrice24hrPercentChange) < 0
                              ? "red"
                              : "yellow",
                        }}>
                          {token?.usdPrice24hrPercentChange !== undefined
                            ? `${token.usdPrice24hrPercentChange}%`
                            : "N/A"}
                        </td>
                        <td>${token?.usdPrice || "0.00"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div style={{ color: "white", textAlign: "center", marginTop: "2rem" }}>
              No token balances found.
            </div>
          )}
        </>
      )}

      <ReceiveModal isOpen={isReceiveModalOpen} setIsOpen={setIsReceiveModalOpen} onClose={handleToggleReceiveModal} />
      <SendModal isOpen={isSendModalOpen} onClose={handleToggleSendModal} />
    </div>
  );
}
